import { render, staticRenderFns } from "./DesignEditPanel.vue?vue&type=template&id=ec463db4&scoped=true"
import script from "./DesignEditPanel.vue?vue&type=script&lang=js"
export * from "./DesignEditPanel.vue?vue&type=script&lang=js"
import style0 from "./DesignEditPanel.vue?vue&type=style&index=0&id=ec463db4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec463db4",
  null
  
)

export default component.exports